import { Edit, Delete } from '@mui/icons-material';
import { Grid, IconButton } from '@mui/material';
import { Cell } from 'react-table';
import { deleteAssignedCredsToWorkspaceUser } from 'wisestep-api';
import { WsColors, WsDataTable } from 'wisestep-base';

interface ShareCreditsTableProps {
  data: keyPair;
  onDelete: () => void;
  onEdit: (a: string) => void;
}
interface keyPair {
  [key: string]: string | null;
}
const ShareCreditTable = ({ data, onDelete, onEdit }: ShareCreditsTableProps) => {
  const DeleteCredits = async (id: string) => {
    await deleteAssignedCredsToWorkspaceUser(id);
    onDelete();
  };

  const columns = [
    { accessor: 'workspaceUser', Header: 'Workspace User' },
    { accessor: 'mailingCredits', Header: 'Mailing Credits/Day' },
    {
      accessor: 'actions',
      Header: 'Actions',
      Cell: (a: Cell) => (
        <Grid item container>
          <IconButton onClick={() => onEdit(a.value)}>
            <Edit sx={{ color: WsColors.TheBlues500 }} />
          </IconButton>
          <IconButton onClick={() => DeleteCredits(a.value)}>
            <Delete sx={{ color: WsColors.Red500 }} />
          </IconButton>
        </Grid>
      ),
    },
  ];
  const values = Object.values(data);
  const keys = Object.keys(data);

  const Data = values.map((val, index) => ({
    workspaceUser: keys[index],
    mailingCredits: val,
    actions: keys[index],
  }));

  return (
    <WsDataTable
      columns={columns}
      data={Data || []}
      totalDataItems={Data.length}
      boldItems={['workspaceUser']}
    />
  );
};
export default ShareCreditTable;
